import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import styled from 'styled-components';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { H5 } from 'foundations-components/transitional/components/H5';
// @ts-expect-error untyped module
import PreloadedIframeProxy from 'ContentEditorUI/components/temp/PreloadedIframeProxytoExtract';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSidebarIframeWrapperElement } from 'ContentEditorUI/lib/layoutDom';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
// @ts-expect-error untyped module
import { updateSidebarSearchQuery } from 'ContentEditorUI/redux/actions/sidebarActions';
// @ts-expect-error untyped module
import SidebarIframeStylesManager from 'ContentEditorUI/utils/SidebarIframeStylesManager';
import PatagoniaSearchBarContainer from 'ContentEditorUI/js/components/sidebar/PatagoniaSearchBarContainer';
import { getHasSectionsLibraryAccess } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Prevents the tabs from overflowing into a "More" menu when searching in "with count" state
const PatagoniaAddModuleMenuWrapper = styled.div.withConfig({
  displayName: "PatagoniaAddModuleMenu__PatagoniaAddModuleMenuWrapper"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    '[role="tab"]': {
      paddingInline: theme.space['0']
    }
  };
});
const PatagoniaAddModuleMenu = ({
  categories,
  categoryYamlMapping,
  categorySelected,
  handleSelectedCategory,
  sidebarIframeIsVisible,
  sidebarSearchResultsMap,
  sidebarSearchQuery
}) => {
  const dispatch = useDispatch();
  const isInNonDefaultBreakpointMode = useSelector(getIsInNonDefaultBreakpointMode);
  const hasSectionsLibraryAccess = useSelector(getHasSectionsLibraryAccess);
  const handleSearchInput = useCallback(input => {
    dispatch(updateSidebarSearchQuery(input));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PatagoniaSearchBarContainer, {
      sidebarSearchQuery: sidebarSearchQuery,
      handleSearchInput: handleSearchInput,
      isDisabled: isInNonDefaultBreakpointMode
    }), categories.length > 1 && /*#__PURE__*/_jsx(Tabs, {
      use: "default",
      Wrapper: PatagoniaAddModuleMenuWrapper,
      selected: categorySelected,
      hideBorders: "both",
      fill: true,
      panelStyles: {
        padding: '0',
        paddingBlockStart: '50'
      },
      children: categories.map(category => {
        const titleMessage = sidebarSearchQuery ? categoryYamlMapping[`${category}_WITH_COUNT`] : categoryYamlMapping[category];
        const count = sidebarSearchQuery ? sidebarSearchResultsMap[category].count : 0;
        return /*#__PURE__*/_jsx(Tab, {
          disabled: isInNonDefaultBreakpointMode,
          tabId: category,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleMessage,
            options: {
              count
            }
          }),
          onClick: () => handleSelectedCategory(category),
          children: sidebarIframeIsVisible && /*#__PURE__*/_jsx(PreloadedIframeProxy, {
            proxyTop: true,
            proxyDisplay: true,
            proxyResizeDependencies: [],
            iframeWrapperElement: getSidebarIframeWrapperElement(),
            isSidebar: true,
            iframeStylesManager: SidebarIframeStylesManager
          })
        }, `addModuleCategory-${category}`);
      })
    }), categories.length === 1 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!hasSectionsLibraryAccess && /*#__PURE__*/_jsx(H5, {
        marginInlineStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: categoryYamlMapping[categories[0]]
        })
      }), sidebarIframeIsVisible && /*#__PURE__*/_jsx(PreloadedIframeProxy, {
        proxyTop: true,
        proxyDisplay: true,
        proxyResizeDependencies: [],
        iframeWrapperElement: getSidebarIframeWrapperElement(),
        isSidebar: true,
        iframeStylesManager: SidebarIframeStylesManager
      })]
    })]
  });
};
export default PatagoniaAddModuleMenu;